import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertCircle } from 'lucide-react';
import { Section } from './ui/Section';
const painPoints = [{
  vivis: 'Domingo buscando fichas de Física y Química que nunca están alineadas al EBI real',
  cuesta: 'Horas perdidas · Energía agotada'
}, {
  vivis: 'Planificaciones de Historia armadas la noche anterior a las corridas',
  cuesta: 'Estrés · Ansiedad · Sensación de que nunca alcanza'
}, {
  vivis: 'Evaluaciones de Geografía sin rúbricas ni criterios claros',
  cuesta: 'Evaluar sin norte · Sin fundamentación real'
}, {
  vivis: 'Ciencias de la Tierra y Ciudadanía sin articulación entre sí',
  cuesta: 'Clases desconectadas que confunden a los niños'
}, {
  vivis: 'Material que no está alineado al Programa EBI vigente de ANEP',
  cuesta: 'Tensión con dirección · con inspección · con vos misma'
}, {
  vivis: 'Fin de semana agotado y el domingo volvés a empezar el mismo ciclo',
  cuesta: 'El mismo desgaste · El próximo año · Y el siguiente'
}];
export const PainSection = () => {
  return <Section background="white" data-id="element-188">
      <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-189">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-extrabold text-stone-900 mb-6" data-id="element-190">
          ¿Cuántos fines de semana más vas a perder así?
        </motion.h2>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg text-stone-600 space-y-4 font-medium" data-id="element-191">
          <p data-id="element-192">Sos maestra del Tramo 2. Amás tu trabajo. Amás a tus alumnos.</p>
          <p data-id="element-193">
            Pero nadie te dijo que ibas a pasar los domingos buscando fichas de
            Física y Química que no encajan con el EBI, armando planificaciones
            de Historia a la noche y llegando al lunes con material de Geografía
            que "más o menos sirve".
          </p>
          <p className="text-stone-900 font-bold text-xl pt-2" data-id="element-194">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </motion.div>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-195">
        <div className="text-center mb-8" data-id="element-196">
          <h3 className="inline-flex items-center gap-2 text-red-600 font-bold bg-red-50 px-4 py-2 rounded-full" data-id="element-197">
            <XCircle className="w-5 h-5" data-id="element-198" />
            EL CICLO QUE SE REPITE CADA SEMANA
          </h3>
        </div>

        {/* Desktop Table View */}
        <div className="hidden md:block bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden" data-id="element-199">
          <div className="grid grid-cols-2 bg-stone-50 border-b border-stone-200" data-id="element-200">
            <div className="p-4 font-bold text-stone-700 flex items-center gap-2" data-id="element-201">
              <XCircle className="w-4 h-4 text-red-500" data-id="element-202" /> Lo que vivís
            </div>
            <div className="p-4 font-bold text-stone-700 flex items-center gap-2 border-l border-stone-200" data-id="element-203">
              <AlertCircle className="w-4 h-4 text-amber-500" data-id="element-204" /> Lo que te
              cuesta
            </div>
          </div>
          <div className="divide-y divide-stone-100" data-id="element-205">
            {painPoints.map((point, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-stone-50/50 transition-colors" data-id="element-206">
                <div className="p-4 text-stone-600" data-id="element-207">{point.vivis}</div>
                <div className="p-4 text-stone-800 font-medium border-l border-stone-100 bg-red-50/30" data-id="element-208">
                  {point.cuesta}
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile Cards View */}
        <div className="md:hidden space-y-4" data-id="element-209">
          {painPoints.map((point, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-stone-200 overflow-hidden" data-id="element-210">
              <div className="p-4 border-b border-stone-100" data-id="element-211">
                <div className="text-xs font-bold text-red-500 uppercase tracking-wider mb-1 flex items-center gap-1" data-id="element-212">
                  <XCircle className="w-3 h-3" data-id="element-213" /> Lo que vivís
                </div>
                <div className="text-stone-700 text-sm" data-id="element-214">{point.vivis}</div>
              </div>
              <div className="p-4 bg-red-50/30" data-id="element-215">
                <div className="text-xs font-bold text-amber-600 uppercase tracking-wider mb-1 flex items-center gap-1" data-id="element-216">
                  <AlertCircle className="w-3 h-3" data-id="element-217" /> Lo que te cuesta
                </div>
                <div className="text-stone-900 font-medium text-sm" data-id="element-218">
                  {point.cuesta}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
};